@let users = users$ | async;
@let isArabic = isArabic$ | async;
@let total = total$ | async;
@let isMapView = isMapView$ | async;

<ul
  class="nav nav-tabs d-flex justify-content-center pt-3 border-primary"
  #mapToggle
  id="searchResultTabs"
  role="tablist"
>
  <li class="nav-item" role="presentation">
    <button
      class="nav-link"
      [ngClass]="isMapView ? '' : 'active'"
      id="list-tab"
      data-bs-toggle="tab"
      data-bs-target="#list-pane"
      type="button"
      role="tab"
      aria-controls="list-pane"
      aria-selected="true"
      (click)="setMapView(false)"
    >
      <i class="bi bi-grid-fill"></i>
      {{ 'LIST_VIEW' | translate }}
    </button>
  </li>

  <li class="nav-item" role="presentation">
    <button
      class="nav-link"
      [ngClass]="isMapView ? 'active' : ''"
      id="map-tab"
      data-bs-toggle="tab"
      data-bs-target="#map-pane"
      type="button"
      role="tab"
      (click)="setMapView(true)"
    >
      <i class="bi bi-map-fill"></i>
      {{ 'MAP_VIEW' | translate }}
    </button>
  </li>
</ul>

<div class="tab-content" id="searchResultTabsContent">
  <!-- LIST TAB -->
  <div
    class="tab-pane fade"
    [ngClass]="isMapView ? '' : 'active show'"
    id="list-pane"
    role="tabpanel"
    aria-labelledby="list-tab"
  >
    @if (total && total > 0) {
      <div class="pt-4 rounded-top-5">
        <div class="row mt-4">
          <!-- order component -->
          <div
            class="col-12 mb-3 d-flex justify-content-between align-items-center"
            [ngClass]="isArabic ? 'text-end' : 'text-start'"
          >
            <div class="dropdown d-inline-block">
              <button
                class="btn btn-outline-primary d-flex align-items-center gap-2"
                type="button"
                data-bs-toggle="dropdown"
              >
                <i class="bi" [ngClass]="sortIcon"></i>
                <span class="fw-semibold">{{ sortLabel | translate }}</span>
              </button>

              <ul
                class="dropdown-menu dropdown-menu-end"
                [ngClass]="isArabic ? 'rtl-mode' : 'ltr-mode'"
              >
                <li>
                  <button
                    class="dropdown-item"
                    [class.active]="sortProperty === 'name'"
                    (click)="setSort('name')"
                  >
                    {{ 'ORDER_BY_NAME' | translate }}
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    [class.active]="sortProperty === 'createdAt'"
                    (click)="setSort('createdAt')"
                  >
                    {{ 'ORDER_BY_USER_DATE' | translate }}
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    [class.active]="sortProperty === 'email'"
                    (click)="setSort('email')"
                  >
                    {{ 'ORDER_BY_EMAIL' | translate }}
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    [class.active]="sortProperty === 'carCount'"
                    (click)="setSort('carCount')"
                  >
                    {{ 'ORDER_BY_CAR_COUNT' | translate }}
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    [class.active]="sortProperty === 'realEstateCount'"
                    (click)="setSort('realEstateCount')"
                  >
                    {{ 'ORDER_BY_PROPERTY_COUNT' | translate }}
                  </button>
                </li>
              </ul>
            </div>

            <span class="text-primary fs-5 border-bottom border-primary"
              >{{ 'ADS' | translate }} {{ total }}
            </span>
          </div>

          <!-- Users -->
          @if (users != null) {
            <user-list [users]="users"></user-list>
          }

          <!-- Pagination component -->
          <div class="col-12 mb-3">
            @let pagination = pagination$ | async;
            @if (
              total !== undefined &&
              total !== null &&
              pagination !== null &&
              total > pagination.pageSize
            ) {
              <nav>
                <ul class="pagination justify-content-center mb-0">
                  <!-- First -->
                  <li class="page-item" [class.disabled]="pagination.pageIndex === 0">
                    <button class="page-link" aria-label="First" (click)="first()">
                      <i
                        class="bi"
                        [ngClass]="isArabic ? 'bi-chevron-double-right' : 'bi-chevron-double-left'"
                      ></i>
                    </button>
                  </li>

                  <!-- Previous -->
                  <li class="page-item" [class.disabled]="pagination.pageIndex === 0">
                    <button class="page-link" (click)="goTo(pagination.pageIndex)">
                      <i
                        class="bi bi-chevron-left"
                        [ngClass]="isArabic ? 'bi-chevron-right' : 'bi-chevron-left'"
                      ></i>
                    </button>
                  </li>

                  <!-- Page Numbers -->
                  @for (page of pages$ | async; track $index) {
                    <li class="page-item" [class.active]="page === pagination.pageIndex + 1">
                      <button class="page-link" (click)="goTo(page)">
                        {{ page }}
                      </button>
                    </li>
                  }

                  <!-- Next -->
                  <li class="page-item" [class.disabled]="isLastPage(total, pagination)">
                    <button class="page-link" (click)="goTo(pagination.pageIndex + 2)">
                      <i
                        class="bi"
                        [ngClass]="isArabic ? 'bi-chevron-left' : 'bi-chevron-right'"
                      ></i>
                    </button>
                  </li>
                  <!-- Last -->
                  <li class="page-item" [class.disabled]="isLastPage(total, pagination)">
                    <button class="page-link" (click)="last(total, pagination.pageSize)">
                      <i
                        class="bi"
                        [ngClass]="isArabic ? 'bi-chevron-double-left' : 'bi-chevron-double-right'"
                      ></i>
                    </button>
                  </li>
                </ul>
              </nav>
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="alert text-center mt-3 bg-primary text-dark">
        {{ 'NO_USERS_FOUND' | translate }}
      </div>
    }
  </div>

  <!-- MAP TAB -->
  @let allUsers = allUsers$ | async;
  <div
    class="tab-pane fade"
    [ngClass]="isMapView ? 'active show' : ''"
    id="map-pane"
    role="tabpanel"
    aria-labelledby="map-tab"
  >
    <app-map-result
      [result]="allUsers ?? []"
      [mapParameters]="mapParameters"
      icon="map-point"
      (mapChanged)="updateMap($event)"
    ></app-map-result>
  </div>
</div>
